import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ReadingCompBookIcon from '../../Global/Icons/ReadingCompBookIcon';
import './NonverbalReadTextButton.scss';

export default function NonverbalReadTextButton({ 
  onClick, 
  disabled,
  small,
  label,
  showPointer,
  pointerPosition
}) {
  const containerClasses = cx({
    'nonverbal-read-text-container': true,
    'small': small,
  });

  const buttonClasses = cx({
    'nonverbal-read-text-button': true,
    'disabled': disabled,
    'small': small,
    'pointerTarget': true,
    'showPointer': showPointer,
    [pointerPosition]: true,
  });

  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <div className={containerClasses}>
      <button 
        className={buttonClasses}
        onClick={handleClick}
        disabled={disabled}
        aria-label={label || "Read Text"}
      >
        <div className="button-content">
          <ReadingCompBookIcon className="book-icon" />
          {label && <span className="button-label">{label}</span>}
        </div>
      </button>
    </div>
  );
}

NonverbalReadTextButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
  label: PropTypes.string,
  showPointer: PropTypes.bool,
  pointerPosition: PropTypes.string,
};

NonverbalReadTextButton.defaultProps = {
  disabled: false,
  small: false,
  label: 'Read Text',
  showPointer: false,
  pointerPosition: '',
};
